import Phaser from "phaser";

/**
 * Finale (Kirby relay) tag-in / tag-out handoff animations, packed by
 * tools/pack-enemy.mjs (union-trimmed, 256px). Texture key === anim key; each is
 * a one-shot. Frame sizes come from the packer's output.
 */
export const RELAY = {
  "dan-tag-out": { frames: 19, fw: 255, fh: 256 },
  "lukas-tag-out": { frames: 15, fw: 213, fh: 256 },
  "lukas-tag-in": { frames: 18, fw: 239, fh: 256 },
  "andrew-tag-in": { frames: 17, fw: 256, fh: 216 },
} as const;

export type RelayKey = keyof typeof RELAY;

/**
 * Relay order and each runner's tags. Dan starts (only ever tags out), Andrew
 * finishes (only ever tags in), Lucas does both. Indexed to match the finale's
 * phase order (LEVELS: dan → lucas → andrew).
 */
export const RELAY_ORDER: { id: string; tagIn: RelayKey | null; tagOut: RelayKey | null }[] = [
  { id: "dan", tagIn: null, tagOut: "dan-tag-out" },
  { id: "lucas", tagIn: "lukas-tag-in", tagOut: "lukas-tag-out" },
  { id: "andrew", tagIn: "andrew-tag-in", tagOut: null },
];

export function loadRelay(scene: Phaser.Scene) {
  for (const key of Object.keys(RELAY) as RelayKey[]) {
    scene.load.spritesheet(key, `assets/sprites/${key}.png`, { frameWidth: RELAY[key].fw, frameHeight: RELAY[key].fh });
  }
}

export function registerRelayAnims(scene: Phaser.Scene) {
  for (const key of Object.keys(RELAY) as RelayKey[]) {
    if (scene.anims.exists(key)) continue;
    scene.anims.create({
      key,
      frames: scene.anims.generateFrameNumbers(key, { start: 0, end: RELAY[key].frames - 1 }),
      frameRate: 20,
      repeat: 0, // one-shot handoff
    });
  }
}
